import { OPTIMIZELY_FEATURE_FLAGS_KEYS, PARTNERS_SCHEDULE_V2_ROLLOUT } from 'components/Optimizely/Optimizely.features';

import { useIsFeatureEnabled } from './useIsFeatureEnabled';

export function useIsScheduleV2RolloutEnabled() {
  return useIsFeatureEnabled(OPTIMIZELY_FEATURE_FLAGS_KEYS[PARTNERS_SCHEDULE_V2_ROLLOUT]);
}
